<template>
  <div class="bottom-container">
      <div class="bottom-box">
            <div class="logo-box">
                <img class="logo-icon" :src="require('@/assets/images/bottom/logo.png')" alt="logo加载失败" @click="goToHomePage()">
            </div>
            <div class="description-box">
                <div class="description-item"  v-for="(items, index) in bottomData" :key="index">
                    <p class="title">{{items.title}}</p>
                    <div class="description">
                        <p v-for="(subItem,key) in items.description" :key="key">{{subItem}}</p>
                    </div>
                </div>
            </div>
            <div class="contact-container">
                <div class="contact-box">
                    <p class="title">联系我们</p>
                    <div class="phone-box">
                        <span class="phone">17769553399</span>
                        <span class="phone">0570-3358803</span>
                    </div>
                    <p class="address">浙江省衢州市柯城区芹江东路288号衢时代创新大厦16楼</p>
                    <div class="qr-box">
                        <div>
                            <p class="qr-title">官方公众号</p>
                            <img class="qr-img" :src="require('@/assets/images/bottom/QR-code-1.png')" alt="公众号图片加载失败">
                        </div>
                        <div>
                            <p class="qr-title">官方视频号</p>
                            <img class="qr-img" :src="require('@/assets/images/bottom/QR-code-2.png')" alt="公众号图片加载失败">
                        </div>
                    </div>
                </div>
                
            </div>
      </div>
        <div class="bottom-end" @click="gotoBeian()">
            <p class="content">©2024 衢州东南飞视科技有限公司版权所有    浙ICP备2024062902号</p>
        </div>
  </div>
</template>

<script>
export default {
    name: 'Bottom',
    data() {
      return{
          bottomData:[
            {title:"飞视平台",description:[
                "综合飞一次看板","业主工作台","飞视巡检小程序"
            ]},
            {title:"增值服务",description:[
                "三维建模服务","全景影像服务","正射影像服务"
            ]},
            {title:"行业应用与案例",description:[
                "工业园区","农林水利","城市管理","道路交通","乡镇街道","应急救援"
            ]}
        ]
      }
    },
    methods:{
        goToHomePage(){
            if (this.$route.path !== '/homepage') {  
                this.$router.push('/homepage');  
            }
        },
        gotoBeian(){
            window.open('http://beian.miit.gov.cn/', '_blank')
        },
    }
}
</script>

<style lang="scss" scoped>
.bottom-container{
    width: 100%;
    position: relative;
    font-weight: 500;
    letter-spacing: 0px;
    color: #FFFFFF;
    background-color: #000000;
    margin: 0;
    padding: 0 40px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .bottom-box{
        max-width: 1440px;
        width: 100%;
        height: 274px;
        display: flex;
        margin: 0;
        margin-top: 70px;
        margin-bottom: 46px;

        .logo-box{
            flex:1 1 18%;
            width: 100%;
            .logo-icon{
                max-width: 140px;
                width: 100%;
                height: 54px;
                flex-shrink: 1;

                &:hover{
                    cursor: pointer;  
                }
            }
        }
        .title{
            max-width: 160px;
            width: 100%;
            height: 20px;
            font-weight: 500;
            font-size: 18px;
            line-height: 20px;
            margin: 0;
            text-align: left;
        }
        .description-box{
            flex:1 1 44.4%;
            display: flex;
            max-width: 640px;
            width: 100%;
            height: 100%;

            .description-item{
                flex: 1;
                margin: 0;
                text-align: left;
                flex-shrink: 1;
                .title{
                    margin-bottom: 24px;            
                }
                .description p{
                    max-width: 98px;
                    width: 100%;
                    height: 20px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #ffffffcc;
                    line-height: 20px;
                    margin: 0;
                    margin-top: 16px;
                }
            }    
        }
        .contact-container{
            flex:1 1 37.6%;
            height: 274px;
            text-align: left;
            color: #ffffffcc;
            display: flex;
            justify-content: flex-end;
            .contact-box{
                height: 100%;
                max-width:287px; 
                .title{
                    margin-bottom: 22px; 
                    color: #FFFFFF;           
                }
                .phone-box{
                    min-width:287px;
                    width: 100%;
                    height: 24px;
                    display: flex;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 24px;
                    width: 127px;
                    color: #FFFFFF;
                    
                    .phone{
                        height: 100%; 
                        margin: 0;
                        &:first-child{
                            width: 127px;
                            margin-right: 16px;
                        }
                        &:last-child{
                            width: 144px;
                            white-space:nowrap;
                        }
                    }

                }
                .address{
                    max-width: 206px;
                    width: 100%;
                    height: 40px;
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 20px;
                    margin: 0;
                    margin-top: 12px;
                    margin-bottom:24px;
                }
                .qr-box{
                    display: flex;
                    width: 100%;
                    height: 130px;

                    .qr-title{
                        margin: 0;
                        margin-right: 50px;
                        height: 20px;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 20px;
                    }
                    .qr-img{
                        max-width: 100px;
                        max-height: 100px;
                        object-fit: contain;
                        flex-shrink: 1;
                        margin: 0;
                        margin-right: 20px;
                        margin-top: 10px;
                    }
                }
            }
            
        }
    }
    .bottom-end{
        width: 100%;
        height: 60px;
        border-top: 1px solid #ffffff1f;
        cursor: pointer;
        .content{
            width: 432px;
            height: 18px;
            font-weight: 400;
            font-size: 13px;
            color: #ffffffcc;
            text-align: center;
            margin: 0 auto;
            padding-top: 21px;
            padding-bottom: 21px;
        }
    }
}
</style>